import { Component, Inject, OnInit, OnDestroy, ViewEncapsulation } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

import { DataService } from "src/app/Services/dataservice.service";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { ThemePreferenceService, ThemeMode } from "src/app/Services/theme-preference.service";
import { Subscription } from "rxjs";

import { DOCUMENT } from "@angular/common";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { ContactUsService } from "src/app/Services/contactus.service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { TokenService } from "src/app/Services/token.service";

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.component.html",
  styleUrls: ["./about-us.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AboutUsComponent implements OnInit, OnDestroy {
  readonly themeStorageKey = "selectedTheme";
  selectedThemeMode: "light" | "dark" = "light";
  private themeSubscription?: Subscription;
  public ownerForm: UntypedFormGroup;
  messaage: string;
  currentImage: any;
  previousIndex: any;
  showImg = false;
  arrow = false;
  itemCount = 0;
  scrHeight: any;
  scrWidth: any;
  SlideOptions: any;
  profilePicture: string;
  userDisplayName: any;
  userData: any;
  showDefaultImage: boolean;
  email: any;
  phone: any;
  info: any;
  website: any;
  uname: any;
  name: any;
  isLogin = false;
  activeSection = 1;
  checkbox: boolean;
  // whatPageObj = {
  //   imageUrl:
  //     "https://easycmstest.azureedge.net/mediaimage/20cf9e6cbfe74d65ba5451bf265b1f61.jpg",
  //   paraText: `<p class="ql-align-center">We are transforming the online video landscape, and with our step-by-step niche DIY guides platform, you no longer have to limit yourself to old-school paper manual guides and long explainer videos.</p><p class="ql-align-center">With the Flowchest app, you can create branded DIY guides that provide detailed but short step by step quality learning experience for your audience and customers. This way, your customers won't have to worry about skipping steps in an assembly/installation process, and your audience will have a sense of ease in knowing your DIY guide can be easily followed and practiced.</p>`,
  // };
  // howPageObj = {
  //   videoUrl: `https://easycmstest.azureedge.net/mediavideo/65d1dc7f3b89496592d3824d169c5987.mp4`,
  //   paraText: `<p class="ql-align-center">With Flowchest, you have everything you need to create interesting step by step DIY instructions. Paper manual guides are becoming obsolete due to the hassle that comes with following bulky content or having to keep your manual safe for future use. Video guides can also be enormously lengthy and confusing to follow or catch up with.</p><p class="ql-align-center">With the Flowchest, all that your audience or customers need to access your content is the in-app generated QR code, which can be used anytime, anywhere, and on any device. Furthermore, you can update or recreate the content at any time without having to change the hyperlink, therefore nobody will ever lose access after update.</p>`,
  //   imageCardWithLinkModels: [
  //     {
  //       title: "PlayStore",
  //       iconName: "",
  //       description: "",
  //       link: "https://play.google.com/store/apps/details?id=com.shnewframework.Flowchest&pli=1",
  //       imageUrl:
  //         "https://easycmstest.azureedge.net/mediaimage/a6659932bef2447b832f3adee3be0b29.png",
  //       partitionKey: "2516792950705964513",
  //       rowKey: "2516792950701149328",
  //       displayOrder: 0,
  //       isValid: true,
  //       version: "V5",
  //       errorMessage: null,
  //       status: null,
  //       timestamp: null,
  //     },
  //     {
  //       title: "AppleStore",
  //       iconName: "",
  //       description: "",
  //       link: "https://apps.apple.com/gb/app/flowchest/id1606597068",
  //       imageUrl:
  //         "https://easycmstest.azureedge.net/mediaimage/e40d80d3620b49a1b12e2ef018ad55c6.png",
  //       partitionKey: "2516792950705964513",
  //       rowKey: "2516792950693260126",
  //       displayOrder: 1,
  //       isValid: true,
  //       version: "V5",
  //       errorMessage: null,
  //       status: null,
  //       timestamp: null,
  //     },
  //   ],
  // };
  // headingPageObj = {
  //   heading:
  //     "<p>We are changing the way businesses, and content creators get their how-to DIY messages across to their customers and audience.</p>",
  //   partitionKey: "2516930912167041308",
  //   rowKey: "2516930912145576794",
  //   displayOrder: 1,
  //   isValid: true,
  //   version: "V5",
  //   errorMessage: null,
  //   status: "Published",
  //   timestamp: null,
  // };
  // extraHeadingPageObj = {
  //   heading: `<p>“Redefining How-to DIY Guides Content Creation”</p>`,
  // };
  // whyparaPageObj = [
  //   {
  //     tabName: "Quality Content",
  //     paragraphText:
  //       '<p class="ql-align-center">To keep your customers and audience, you need How-to DIY guides that are of high quality and captures the real intention of the guide. That\'s what you can do with Flowchest.</p>',
  //     partitionKey: "2516792952224733394",
  //     rowKey: "2516792952219540455",
  //     displayOrder: 0,
  //     isValid: true,
  //     version: "V3",
  //     errorMessage: null,
  //     status: null,
  //     timestamp: null,
  //   },
  //   {
  //     tabName: "Comprehensive and Engaging",
  //     paragraphText:
  //       '<p class="ql-align-center">As a content creator or product manufacturer, your DIY guides need to not only have immense value but also be endlessly engaging to keep the viewer interested and attentive</p>',
  //     partitionKey: "2516792952224733394",
  //     rowKey: "2516792952211839785",
  //     displayOrder: 1,
  //     isValid: true,
  //     version: "V3",
  //     errorMessage: null,
  //     status: null,
  //     timestamp: null,
  //   },
  //   {
  //     tabName: "More Value and Revenue",
  //     paragraphText:
  //       '<p class="ql-align-center">Producing value-laden how-to DIY videos is a great way to gain higher ROI and increase your audience reach. People buy more when they know they have all the guidance they need to succeed in the endeavor.</p>',
  //     partitionKey: "2516792952224733394",
  //     rowKey: "2516792952203903434",
  //     displayOrder: 2,
  //     isValid: true,
  //     version: "V3",
  //     errorMessage: null,
  //     status: null,
  //     timestamp: null,
  //   },
  // ];
  // communityPageObj = {
  //   paraText: `<p class="ql-align-center">&nbsp;As the end user, you get the benefit of having a central point where you can find all easy how-to guides from diverse content creators and businesses in one place, for everyday use. The end user can engage with the content creators and other users within the app, save content for future use and share with friends and families. We have a huge list of nice to have features in our backlog to further enhance user experience.</p>`,
  //   imageCardWithLinkModels: [
  //     {
  //       title: "Instagram",
  //       iconName: "",
  //       description: "Join us on Instagram",
  //       link: "https://www.instagram.com/flowchest.app/?utm_medium=copy_link",
  //       imageUrl:
  //         "https://easycmstest.azureedge.net/mediaimage/78155df1ce8d47aeaa5627a0f6e6ac2f.png",
  //       partitionKey: "2516969115998629501",
  //       rowKey: "2516969115956587513",
  //       displayOrder: 0,
  //       isValid: true,
  //       version: "V1",
  //       errorMessage: null,
  //       status: null,
  //       timestamp: null,
  //     },
  //   ],
  // };
  isScrolled = false;
  isMobileView = false;
  currentSection = "section1";
  private scrollListener?: () => void;
  private resizeListener?: () => void;
  private scrollAnimationFrameId?: number;
  private intersectionObserver?: IntersectionObserver;
  navigationItems = [
    { id: 'hero', label: 'Hero' },
    { id: 'problem', label: 'Problem' },
    { id: 'insight', label: 'Insight' },
    { id: 'what', label: 'What' },
    { id: 'how', label: 'How' },
    { id: 'who', label: 'Who' },
    { id: 'why', label: 'Why' },
    { id: 'founder', label: 'Story' },
    { id: 'vision', label: 'Vision' },
    { id: 'values', label: 'Values' },
    { id: 'closing', label: 'Closing' }
  ];

  carouselOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['‹', '›'],
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      }
    },
    nav: true,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    margin: 30
  };

  valuesCarouselOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
        center: true,
        stagePadding: 40
      },
      768: {
        items: 2.2,
        center: true,
        stagePadding: 60
      },
      992: {
        items: 2.8,
        center: true,
        stagePadding: 80
      },
      1200: {
        items: 3.2,
        center: true,
        stagePadding: 100
      }
    },
    nav: true,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    margin: -120,
    center: true
  };

  constructor(
    private flowServiceService: FlowServiceService,
    private dataService: DataService,
    private router: Router,
    public route: Router,
    private data: DataService,
    private userserviceService: UserserviceService,
    private eventEmitterService: EventEmitterService,
    private toastr: ToastrService,
    private contactusService: ContactUsService,
    private authModalService: AuthModalService,
    private tokenService: TokenService,
    private themePreferenceService: ThemePreferenceService,
    @Inject(DOCUMENT) private document: any
  ) {}

  fullPageScroll(e: HTMLElement, i) {
    // this.pageScrollService.scroll({
    //   scrollTarget: e,
    //   document: this.document,
    // });
    console.log(e);
    //this.scrollToSection()
    this.scrollsectionToSection(e);
    this.activeSection = i;
  }

  scrollsectionToSection(section: HTMLElement): void {
    if (section) {
      //const element = document.getElementById(section);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  onSrollChangeColor() {
    if (
      document.body.scrollTop > 400 ||
      document.documentElement.scrollTop > 400
    ) {
      document.getElementById("myP").className = "step-section nav-items";
    } else {
      document.getElementById("myP").className = "";
    }
  }

  linkClicked() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          var element = document.querySelector("#" + tree.fragment);
          if (element.className == "section-1") {
            element.className = "section-1 activesection1";
          }
          if (element.className == "section-2") {
            element.className = "section-2 activesection2";
          }
          // element.className="section-5 active";
          if (element) {
            element.scrollIntoView(true);
          }
        }
      }
    });
  }

  openPlayStoreLink() {
    window.open(
      "https://play.google.com/store/apps/details?id=com.shnewframework.Flowchest",
      "_blank"
    );
  }
  openAppleStoreLink() {
    window.open(
      "https://apps.apple.com/gb/app/flowchest/id1606597068",
      "_blank"
    );
  }

  ngOnInit(): void {
    this.themeSubscription = this.themePreferenceService.themeChanges$.subscribe((theme) => {
      this.selectedThemeMode = theme;
    });
    this.initializeThemeMode();
    this.flowServiceService.setScrollTop();
    this.checkMobileView();
    if (typeof window !== 'undefined') {
      this.resizeListener = () => this.checkMobileView();
      window.addEventListener('resize', this.resizeListener);
    }
    
    this.ownerForm = new UntypedFormGroup({
      name: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(60),
      ]),
      message: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(100),
      ]),
      checkbox: new UntypedFormControl(false, Validators.requiredTrue),
      email: new UntypedFormControl("", [
        Validators.required,
        Validators.email,
      ]),
    });

    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));

    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
    }

    if (this.route.url !== "/" || localStorage.getItem("isLogin") === "Yes") {
      this.isLogin = true;
    } else {
      this.data.currentMessagebool.subscribe((res) => (this.isLogin = res));
    }

    this.eventEmitterService.callEvent();
    this.eventEmitterService.setHomePageIconColorEvent("home");

    if (this.eventEmitterService.setProfilePictureCompleted === undefined) {
      this.eventEmitterService.setProfilePictureCompleted =
        this.eventEmitterService.setProfilePictureFunction.subscribe(
          (profilePicture: string) => {
            this.showDefaultImage = false;
            this.profilePicture = profilePicture;
          }
        );
    }

    // this.getWhatPageDetails();
    // this.getHowPageDetails();
    // this.getWhyPageDetails();
    // this.getExtraPageDetails();
    // this.getCommunityPageDetails();

    this.setupScrollTracking();
  }

  checkMobileView(): void {
    if (typeof window !== 'undefined') {
      this.isMobileView = window.innerWidth <= 768;
    }
  }

  toggleSidebar(): void {
    // Access the app component's sidebar through DOM or service
    // Since sidebar is controlled by app component, we'll trigger it via custom event
    const event = new CustomEvent('toggleSidebar');
    window.dispatchEvent(event);
    
    // Also try to directly access the app component if available
    const appComponent = (window as any).appComponent;
    if (appComponent && appComponent.toggleSidebar) {
      appComponent.toggleSidebar();
    }
  }

  get isDarkThemeActive(): boolean {
    return this.selectedThemeMode === "dark";
  }

  toggleThemeMode(): void {
    const nextTheme = this.themePreferenceService.toggleTheme();
    this.persistThemeMode(nextTheme);
  }

  private persistThemeMode(theme: "light" | "dark"): void {
    const userData = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    if (userData?.emailAddress) {
      this.userserviceService
        .UpdateThemeSettingsForCustomerProfileDetails({
          emailAddress: userData.emailAddress,
          selectedTheme: theme,
        })
        .subscribe({
          next: () => {
            userData.selectedTheme = theme;
            localStorage.setItem("LoggedInUser", JSON.stringify(userData));
          },
          error: () => {},
        });
    }
  }

  private initializeThemeMode(): void {
    const theme = this.themePreferenceService.initializeFromStorage();
    this.selectedThemeMode = theme;
  }

  homePage(): void {
    this.router.navigate(["/"]);
  }

  setupScrollTracking(): void {
    if (typeof window !== 'undefined') {
      // Throttle scroll events using requestAnimationFrame for better performance
      this.scrollListener = () => {
        if (this.scrollAnimationFrameId) {
          cancelAnimationFrame(this.scrollAnimationFrameId);
        }
        this.scrollAnimationFrameId = requestAnimationFrame(() => {
          this.isScrolled = window.scrollY > 50;
          this.updateActiveSection();
        });
      };
      window.addEventListener('scroll', this.scrollListener, { passive: true });
      
      // Setup Intersection Observer for scroll animations
      this.setupScrollAnimations();
    }
  }

  setupScrollAnimations(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback: add animate-in class immediately for browsers without support
      const elements = document.querySelectorAll('.section, .feature-card, .step-card, .who-card, .value-item, .comparison-table, .pull-quote');
      elements.forEach(el => el.classList.add('animate-in'));
      return;
    }

    const observerOptions: IntersectionObserverInit = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          // Unobserve after animation to improve performance
          this.intersectionObserver?.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all sections and cards with a slight delay for better performance
    setTimeout(() => {
      const sections = document.querySelectorAll('.section, .feature-card, .step-card, .who-card, .value-item, .comparison-table, .pull-quote');
      sections.forEach(section => {
        this.intersectionObserver?.observe(section);
      });
    }, 100);
  }

  updateActiveSection(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    // Cache section elements to avoid repeated DOM queries
    const headerHeight = 64; // Page header height
    const scrollPosition = window.scrollY + headerHeight + 50;

    // Only query DOM once per update
    for (let i = this.navigationItems.length - 1; i >= 0; i--) {
      const section = document.getElementById(this.navigationItems[i].id);
      if (section && section.offsetTop <= scrollPosition) {
        // Only update if changed to avoid unnecessary change detection
        if (this.activeSection !== i + 1) {
          this.activeSection = i + 1;
        }
        break;
      }
    }
  }

  scrollToSection(sectionId: string): void {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 64; // Page header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  isUserLoggedIn(): boolean {
    const refreshToken = this.tokenService.getRefreshToken();
    const userData = localStorage.getItem("LoggedInUser");
    return !!(refreshToken && userData && userData !== 'null');
  }

  navigateToHowItWorks(): void {
    this.router.navigate(['/how-it-works']);
  }

  navigateToSignUp(): void {
    if (this.isUserLoggedIn()) {
      // If logged in, navigate to create-flow page (Build action)
      this.router.navigate(['/create-guide']);
    } else {
      // If not logged in, show sign-up modal
      this.authModalService.openModal('registration');
    }
  }

  geToEdit() {
    this.router.navigateByUrl("/createAboutUs");
  }

  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }
  scrollTo(section: string): void {
    document.querySelector("#" + section)?.scrollIntoView();
  }
  submit() {
    var contactus = {
      Message: this.messaage,
      Name: this.name,
      Email: this.email,
    };

    this.contactusService.postContactUs(contactus).subscribe((data) => {
      this.toastr.success("Your contact us request is submitted. Thank you");
      this.messaage = "";
      this.name = "";
      this.email = "";

      // Reset the reactive form
      this.ownerForm.reset();
    });
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.ownerForm.controls[controlName].hasError(errorName);
  };

  getProfileUser(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));

    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;

      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.UserData.profilePicUrl === "" ||
          data.UserData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.UserData.profilePicUrl;
          this.eventEmitterService.setProfilePictureEvent(this.profilePicture);
        }
        this.email = data.UserData.emailAddress;
        this.phone = data.UserData.phoneNumber;
        this.info = data.UserData.info;
        this.website = data.UserData.website;
        this.userDisplayName = this.uname = data.UserData.userName;
        this.name = data.UserData.firstName;
      });
    }
  }
  instaLink() {}

  ngOnDestroy(): void {
    this.themeSubscription?.unsubscribe();
    // Clean up scroll listener
    if (this.scrollListener && typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.scrollListener);
    }
    
    // Cancel any pending animation frame
    if (this.scrollAnimationFrameId) {
      cancelAnimationFrame(this.scrollAnimationFrameId);
    }
    
    // Clean up resize listener
    if (this.resizeListener && typeof window !== 'undefined') {
      window.removeEventListener('resize', this.resizeListener);
    }
    
    // Clean up IntersectionObserver
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
}
